import React from 'react'

import clsx from 'clsx'

import ListingsFilterItem from './components/ListingsFilterItem'

import classes from './ListingsFilter.module.scss'

/** @type {import("./types").default} */
const ListingsFilter = ({ filters, selected, onSelect }) => {
  return (
    <div className={clsx('ListingsFilter', classes.root)}>
      <div className={classes.scrollCont}>
        <div className={classes.filterWrap}>
          {filters.map(filter => (
            <ListingsFilterItem
              key={`category-filter-${filter.value}`}
              filter={filter}
              selected={selected}
              onSelect={onSelect}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default ListingsFilter
